import { DraftsState } from "./types";

const initialState: DraftsState = {
  didInvalidate: false,
  isFetching: false,
  error: null,
};

export default initialState;
